import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { NEXT_OF_KIN_RELATIONSHIPS } from "@/lib/clientFields";

/**
 * Composite Next-of-Kin block. Writes 4 flat keys into the record:
 * next_of_kin_name, next_of_kin_relationship, next_of_kin_phone, next_of_kin_email.
 */
export default function NextOfKinFields({ values, onChange, testid = "next-of-kin" }) {
  const set = (k, v) => onChange(k, v);
  return (
    <div className="md:col-span-2 rounded-md border border-slate-200 dark:border-slate-700 bg-slate-50/60 dark:bg-slate-900/40 p-3">
      <div className="text-xs font-semibold text-slate-700 dark:text-slate-200 mb-2 uppercase tracking-wide">
        Next of Kin
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div className="space-y-1">
          <Label htmlFor={`${testid}-name`} className="text-xs font-medium text-slate-700 dark:text-slate-300">Full Name</Label>
          <Input
            id={`${testid}-name`}
            data-testid={`${testid}-name`}
            value={values.next_of_kin_name || ""}
            onChange={(e) => set("next_of_kin_name", e.target.value)}
            className="text-sm h-9 bg-white dark:bg-slate-900"
            autoComplete="off"
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor={`${testid}-relationship`} className="text-xs font-medium text-slate-700 dark:text-slate-300">Relationship</Label>
          <Select
            value={values.next_of_kin_relationship || ""}
            onValueChange={(v) => set("next_of_kin_relationship", v)}
          >
            <SelectTrigger id={`${testid}-relationship`} data-testid={`${testid}-relationship`} className="text-sm h-9 bg-white dark:bg-slate-900">
              <SelectValue placeholder="Select…" />
            </SelectTrigger>
            <SelectContent className="bg-white dark:bg-slate-900">
              {NEXT_OF_KIN_RELATIONSHIPS.map((r) => (
                <SelectItem key={r} value={r} data-testid={`${testid}-relationship-opt-${r}`}>
                  {r}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1">
          <Label htmlFor={`${testid}-phone`} className="text-xs font-medium text-slate-700 dark:text-slate-300">Telephone Number</Label>
          <Input
            id={`${testid}-phone`}
            data-testid={`${testid}-phone`}
            type="tel"
            inputMode="tel"
            value={values.next_of_kin_phone || ""}
            onChange={(e) => set("next_of_kin_phone", e.target.value)}
            className="text-sm h-9 bg-white dark:bg-slate-900"
            placeholder="e.g. +44 20 7946 0000"
            autoComplete="off"
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor={`${testid}-email`} className="text-xs font-medium text-slate-700 dark:text-slate-300">Email Address</Label>
          <Input
            id={`${testid}-email`}
            data-testid={`${testid}-email`}
            type="email"
            value={values.next_of_kin_email || ""}
            onChange={(e) => set("next_of_kin_email", e.target.value)}
            className="text-sm h-9 bg-white dark:bg-slate-900"
            placeholder="name@example.com"
            autoComplete="off"
          />
        </div>
      </div>
    </div>
  );
}
